import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { queryClient } from './lib/queryClient';
import '@solid/ui/globals.css';
import './styles/globals.css';
import './styles/print.css';

// Check if the App Rail is present
const checkAppRail = () => {
  const appRailElement = document.getElementById('solid-app-rail');
  return !!appRailElement;
};

// Render the app
const renderApp = () => {
  const isEmbedded = checkAppRail();

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App isEmbedded={isEmbedded} />
        </BrowserRouter>
      </QueryClientProvider>
    </React.StrictMode>
  );
};

// App Rail auto-initializes via script tag, just render the app
renderApp();
